import { types, getRoot, getParent } from 'mobx-state-tree';

const TreeNode = types.model('TreeNode', {
    Name: types.maybeNull(types.string),
    Url: types.optional(types.string, ""),
    PathSegment: types.optional(types.string, ""),
    Id: types.maybeNull(types.number),
    Guid: types.maybeNull(types.string),
    NodePath: types.optional(types.string, ""),
    Alias: types.optional(types.string, ""),
    Children:
        types.optional(types.array(types.late(() => TreeNode)),
            []),
    Component: types.maybeNull(types.string),
    Roles: types.optional(types.array(types.string), []),
    CustomerRequired: types.maybeNull(types.boolean),
    Icon: types.maybeNull(types.string),
    Protected: types.maybeNull(types.boolean),
    Visible: types.optional(types.boolean, true),
    Highlighted: types.optional(types.boolean, false),
    IsDivider: types.optional(types.boolean, false),
    MobileContentHeight: types.optional(types.number, 0),
    //CategoryIds: types.optional(types.array(types.string), []),
    //Hidden: types.optional(types.boolean, false)
    Properties: types.optional(types.frozen(), {}), // additional data
    ImageUrl: types.maybeNull(types.string)
    
}).views(self => ({
    PropertyByKey(key) {
        const p = self.Properties[key];
        if (p) {
            return p;
        } else {
            return null;
        }
    },

    get Navigation() {
        return getRoot(self).navigation;
    },
    
    ChildrenView() {
        return self.Children;
    },

    get IsProtected() {
        return self.Roles.length > 0 || (self.CustomerRequired && self.CustomerRequired === true);
    },

    get IsHeading() {
        return self.Alias === "icom_menuHeading";
    },


    get HasAccess() {
        if (self.CustomerRequired && self.CustomerRequired === true && self.Navigation.CustomerId === null) {
            return false;
        }
        if (self.Roles.length === 0) {
            return true;
        }

        return self.Roles.filter(value => -1 !== self.Account.Roles.indexOf(value)).length > 0;
    },

    get Account() {
        return getRoot(self).account;
    },

    get Parent() {

        try {
            return getParent(self, 2);
        } catch (e) {
            return null;
        }
    },

    get Path() {
        if (self.Url && self.Url.length > 0) return self.Url;

        let node = self;
        let path = "";
        while (node) {
            //console.debug("path", node); 
            path = "/" + node.PathSegment + path;
            try {
                node = getParent(node, 2); // Jump array list

                // Handle Tree and TreeNode.
                if (node.$treenode.type.name.substr(0, 8) !== "TreeNode") {
                    node = null;
                }
            } catch (e) {
                node = null;
            }
        }
        return path;
    }
})).actions(self => ({
    setMobileContentHeight(height) {
        self.MobileContentHeight = height;
    }, getNode(id) {
        if (id === self.Id) {
            return self;
        } else {
            for (const node of self.ChildrenView()) {  
                const result = node.getNode(id);
                if (result !== null) {
                    return result;
                }
            }
        }

        return null;
    }
}));

export default TreeNode;
